module.exports = __webpack_public_path__ + "media/images/footer_docs-1d7d3fdfb86b7651b11e9e5cb569b18c.png";